import { ViewController, NavParams } from 'ionic-angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'lm-select',
    templateUrl: 'select.component.html'
})

export class SelectComponent {

    @Input() public title: string;
    @Input() public options: {title: string, value: any};

    constructor(private viewController: ViewController, navParams: NavParams) {
        this.options = navParams.get('options');
        this.title = navParams.get('title');
    }

    public didTapOption(option: {title: string, value: any}) {
        this.viewController.dismiss(option);
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/selectComponent/select.component.ts